module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-hide"
  }, [_c('div', {
    staticClass: "recharge_types card_choose"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "vip_input"
  }, [_c('div', [_c('input', {
    staticClass: "ol_card",
    attrs: {
      "type": "button",
      "value": "线上办卡"
    },
    on: {
      "click": _vm.goOnline
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "r_card",
    attrs: {
      "type": "button",
      "value": "绑定会员卡"
    },
    on: {
      "click": _vm.goMain
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip_card"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/vip.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip_p"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/context_img.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-87e3eb4a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/module/main/views/card_choose.vue
// module id = 219
// module chunks = 1